import axios from "axios";
import {HOST} from "./index";

export function Put(path, body = {}) {
    return axios.put(HOST + path, body);
}

export function PutWithAuth(path, token, body = {}) {
    return axios.put(HOST + path, body, {
        headers: {
            "Authorization": token
        }
    });
}